// extracted by mini-css-extract-plugin
export default {"content":"CalculatorSettingsDialog_content__Cv3eq","fullWidth":"CalculatorSettingsDialog_fullWidth__uaxm9"};